import { useContext } from 'react';

import MenuContext from './context';

const useMenu = () => useContext(MenuContext);

export default useMenu;
